import { jsx, jsxs } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
function FilterResultsPart({ part }) {
  if (isCallState(part.state)) return null;
  if (isOutputState(part.state) && part.output) {
    const { originalCount, filteredCount, appliedFilters } = part.output;
    if (originalCount === 0) return null;
    return /* @__PURE__ */ jsx("div", { className: "concierge-search-results", children: /* @__PURE__ */ jsxs("div", { className: "concierge-search-summary", children: [
      "Filtered ",
      originalCount,
      " → ",
      filteredCount,
      " products",
      (appliedFilters == null ? void 0 : appliedFilters.length) > 0 && /* @__PURE__ */ jsxs("span", { children: [
        " (",
        appliedFilters.join(", "),
        ")"
      ] })
    ] }) });
  }
  return null;
}
export {
  FilterResultsPart
};
//# sourceMappingURL=FilterResultsPart.js.map
